import historyManager from 'components/history-manager';
import { foreach, makeUrl } from 'components/utils';
import { activateFilterToggle, activateFilterTextfield } from 'components/search-page-functions';
import $ from 'jquery';
import 'components/fengyuanchen_datepicker';

let searchHandler = null;
let params = historyManager.getUrlParams();

/**
 * Initiates / starts the search: loads results based on the filters from the backend
 */
function initSearch(params, page = 0, allPages = false) {
    showLoader();
    checkTGBubbleHighlight();
    if (searchHandler) {
        searchHandler.abort();
        searchHandler = null;
    }
    // clear result content on first page:
    if (page === 0) {
        resultContainer.html('');
    }
    let shadowParams = Object.assign({}, params);
    shadowParams.page = page;
    shadowParams.allPages = allPages;
    searchHandler = $.get(makeUrl('/kulturplatz/search'), shadowParams)
        .done((res) => {
            resultContainer.append(res);
        })
        .always(() => {
            searchHandler = null;
            hideLoader();
        });
}

/**
 * shows a loading indicator. resultcontainer must be a jquery object.
 */
function showLoader(resultcontainer) {
    loaderContainer.html('<div class="searching"></div>');
}

/**
 * hides a loading indicator. resultcontainer must be a jquery object.
 */
function hideLoader(resultcontainer) {
    loaderContainer.html('');
}

const resultContainer = $('#searchresult-container');
const loaderContainer = $('#loader-container');

// Init all filter elements that listen for user click / history changes:
let filterLinks = document.querySelectorAll(
    'a[data-filter],li[data-filter],input[data-filter][type=checkbox],polygon[data-filter],rect[data-filter]',
);
let filterTextfields = document.querySelectorAll('input[data-filter][type=search]');

foreach(filterLinks, activateFilterToggle);
foreach(filterTextfields, activateFilterTextfield);

historyManager.history.listen((location, action) => {
    let params = historyManager.getUrlParams();
    let actualPage = Number(params.page) || 0;
    initSearch(params, actualPage);
});

// Clear all filters listener: removes all filters:
$('#reset,input[type=reset]').on('click', (e) => {
    historyManager.pushParams({});
    // to settle the original map clicks first, wait a bit
    setTimeout(checkTGBubbleHighlight, 10);
});

// more button
$('#moreBtn').on('click', (e) => {
    let params = historyManager.getUrlParams();
    params.page = (Number(params.page) || 0) + 1;
    historyManager.pushParams(params, false);
});

/** ---------------------- Map buttons handling ------------------------------- */
// Region-TG-Button
let tgRegions = ['frauenfeld', 'kreuzlingen', 'weinfelden', 'arbon', 'muenchwilen'];
$('#region-tg').on('click', (e) => {
    let params = historyManager.getUrlParams();
    params.region = tgRegions;
    historyManager.pushParams(params);
    setTimeout(checkTGBubbleHighlight, 10);
});
$('#region-extern').on('click', (e) => {
    let params = historyManager.getUrlParams();
    params.region = ['extern'];
    historyManager.pushParams(params);
});

// On each click on an SVG Map Part, we need to check if all "TG" region is selected,
// to also toggle the TG button (See #13813):
$('[data-filter=region]').on('click', (e) => {
    // to settle the original map clicks first, wait a bit
    setTimeout(checkTGBubbleHighlight, 10);
});

let checkTGBubbleHighlight = function () {
    let selected = historyManager.getUrlParams().region;
    if (!(selected instanceof Array)) {
        selected = [selected];
    }
    // Check if the selected regions are all selected: hightlight
    // the TG button if, else deselect:
    let all = true;
    for (let i = 0; i < tgRegions.length; i++) {
        if (selected.indexOf(tgRegions[i]) === -1) {
            all = false;
            break;
        }
    }
    if (all) {
        $('#region-tg').addClass('active');
    } else {
        $('#region-tg').removeClass('active');
    }
};

/** ---------------------- END Map buttons handling ------------------------------- */

/** ---------------------- filter accept mobile - some special handling for non-standard fields: */
$('.filteracceptmobile,button.searchsubmit').on('click', (e) => {
    // Emulate key / click events on the original elements:
    let keyEvt = new Event('keypress');
    keyEvt.keyCode = 13;

    $('[data-filter=query]')[0].dispatchEvent(keyEvt);
});
/** ------------------------------------------------------------------------------*/

// start first initial search
// See #13314: All TG regions must be selected by default:
(() => {
    if (Object.keys(params).length === 0) {
        $('#region-tg').trigger('click');
        $('#region-tg').addClass('active');

        // also, select the default sort:
        $('#sort-default').trigger('click');
        $('#sort-default').addClass('active');
    } else {
        initSearch(params, Number(params.page) || 0, true);
    }
})();

/** ------------------------------ Initial Filter container open --------------------------*/
/** Containers that have active filter params set are set to open on page load */
(() => {
    let params = historyManager.getUrlParams();
    Object.keys(params).forEach((key) => {
        let selector = `[data-filter-container*=${key}]`;
        $(selector).addClass('open');
    });
})();
